module.exports = __webpack_public_path__ + "img/gift-letter.d79b9809.png";